import React from 'react';
import { Alert, Box, Typography } from '@availity/element';

const HIPAABanner = () => (
  <Alert
    severity="info"
    elevation={6}
    icon={false}
    sx={{
      maxWidth: '444px',
      padding: 2,
    }}
  >
    <Typography variant="subtitle2">
      <Box component="span" sx={{ fontWeight: 'bold' }}>
        Note:
      </Box>{' '}
      Your Availity account and login credentials belong only to you. Sharing accounts may violate HIPAA regulations
      regarding data privacy.
    </Typography>
  </Alert>
);

export default HIPAABanner;
